import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
export var PrecisePriceLogoIcon = function PrecisePriceLogoIcon(props) {
  var _props$viewBox = props.viewBox,
      viewBox = _props$viewBox === void 0 ? '0 0 38 38' : _props$viewBox,
      _props$width = props.width,
      width = _props$width === void 0 ? '24px' : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? '24px' : _props$height;
  var classes = useStyles(props);
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: width,
      height: height,
      viewBox: viewBox
    },
    /*#__PURE__*/
    React.createElement("path", {
      className: classes.cls1,
      d: "M18.75,-1.0658141e-14 C29.1066217,-1.0658141e-14 37.5,8.39376112 37.5,18.7491449 C37.5,29.1045287 29.1066217,37.5 18.75,37.5 C8.39508847,37.5 2.48689958e-14,29.1045287 2.48689958e-14,18.7491449 C2.48689958e-14,8.39376112 8.39508847,-1.0658141e-14 18.75,-1.0658141e-14 Z M16.310482,12.0921125 L10.4122013,17.9923724 C8.73113143,19.6718087 8.73113143,22.3961896 10.4122013,24.0756259 L13.8974713,27.5610549 C15.576831,29.2422014 18.3010877,29.2422014 19.9804474,27.5610549 L25.8804383,21.6625051 C27.619653,19.9232111 28.5345791,17.5237721 28.3960576,15.0678957 L28.1019131,9.87053633 L22.9030805,9.57637844 C20.4490264,9.4378506 18.0496967,10.3528184 16.310482,12.0921125 Z M24.7825269,13.1900739 C25.9214817,14.3307908 25.9214817,16.1761185 24.7825269,17.3151252 C23.6435721,18.4524217 21.7966185,18.4524217 20.6576637,17.3151252 C19.518709,16.1761185 19.518709,14.3307908 20.6576637,13.1900739 C21.7966185,12.0510672 23.6435721,12.0510672 24.7825269,13.1900739 Z"
    }))
  );
};
var useStyles = makeStyles(function (theme) {
  return {
    cls1: function cls1(props) {
      return {
        fill: props.color ? props.color : theme.palette.product.precisePrice,
        fillRule: 'evenodd'
      };
    }
  };
});